// Plan de pagos (sesión #6, Carlos): de 1 a 11 cuotas financiadas por la aseguradora, con valor y fecha de cada una.
// La primera vence a los 30 días del inicio de la vigencia (plazo para pagar) y las demás cada mes; la última
// absorbe el redondeo para que la suma dé exacto el total anual.
export const MAX_CUOTAS = 11;
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

export const fechaCorta = (d) => `${d.getDate()}-${MESES[d.getMonth()]}-${d.getFullYear()}`;

export function planCuotas(anual, cuotas, inicio = new Date()) {
  const n = Math.min(Math.max(Number(cuotas) || MAX_CUOTAS, 1), MAX_CUOTAS);
  const valor = Math.round(anual / n);
  const primera = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate() + 30);
  return Array.from({ length: n }, (_, k) => {
    const vence = new Date(primera.getFullYear(), primera.getMonth() + k, primera.getDate());
    return { i: k + 1, n, valor: k === n - 1 ? anual - valor * (n - 1) : valor, vence };
  });
}
